import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCallback, useMemo } from 'react';
import { Select } from 'foundations-components/transitional/components/Select/Select'; //TODO: temp direct import
import { usePipelines } from '../context/PipelinesContext';
import unescapedText from 'I18n/utils/unescapedText';
import { ALL_PIPELINES_VALUE } from '../constants/AllPipelinesValue';
import { useCurrentPipelineId } from '../hooks/useCurrentPipelineId';
import { useCurrentPageType } from '../../../views/hooks/useCurrentPageType';
import { BOARD } from '../../../views/constants/PageType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DEAL_TYPE_ID, TASK_TYPE_ID, TICKET_TYPE_ID, CONTACT_TYPE_ID, COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { HIDDEN } from 'crm_data/pipelinePermissions/pipelinePermissionsConstants';
import getIn from 'transmute/getIn';
import { Link } from 'foundations-components/transitional/components/Link';
import { getPipelineSettingsHref } from '../../../utils/getPipelineSettingsHref';
import { Flex } from 'foundations-components/components/Flex';
import { useCurrentObjectType, useSegment } from 'crm-index-visualization-core';
import { gate } from 'hub-http/gates';
import { useHasAllGates } from '../../../auth/hooks/useHasAllGates';
import { useSelectedObjectTypeId } from '../../../objectTypeIdContext/hooks/useSelectedObjectTypeId';
import { useSwitchPipelines } from '../hooks/useSwitchPipelines';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectItemWithTooltip = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: option.placement || 'left',
      title: option.tooltip,
      disabled: !option.disabled,
      children: /*#__PURE__*/_jsx("span", {
        children: children
      })
    })
  }));
};

// FIXME Instead of checking by type, why don't we hide pipeline based on how many actual pipeline there are to switch. - Thanh
export const hidePipelineSwitcher = objectTypeId =>
// Tasks always have one and only one pipeline with no customization
objectTypeId === TASK_TYPE_ID || objectTypeId === CONTACT_TYPE_ID || objectTypeId === COMPANY_TYPE_ID;
export const getAllPipelinesTooltipMessage = objectTypeId => {
  switch (objectTypeId) {
    case DEAL_TYPE_ID:
      {
        return 'filterSidebar.allPipelinesDisabled.DEAL';
      }
    case TICKET_TYPE_ID:
      {
        return 'filterSidebar.allPipelinesDisabled.TICKET';
      }
    default:
      {
        return 'filterSidebar.allPipelinesDisabled.object';
      }
  }
};
const PipelineSwitcher = () => {
  var _ref2;
  const hasAllGate = useHasAllGates();
  const useVizCoreLib = hasAllGate(gate('CRM:Index:UseVizCoreLib'));
  const objectTypeIdNew = useCurrentObjectType();
  const objectTypeIdLegacy = useSelectedObjectTypeId();
  const objectTypeId = useVizCoreLib ? objectTypeIdNew : objectTypeIdLegacy;
  const pipelines = usePipelines();
  const pageType = useCurrentPageType();
  const currentPipelineIdLegacy = useCurrentPipelineId() || ALL_PIPELINES_VALUE;
  const {
    data: segmentData
  } = useSegment();
  const currentPipelineId = (_ref2 = useVizCoreLib ? segmentData === null || segmentData === void 0 ? void 0 : segmentData.pipelineId : currentPipelineIdLegacy) !== null && _ref2 !== void 0 ? _ref2 : ALL_PIPELINES_VALUE;
  const allPipelinesOption = useMemo(() => {
    const disabled = pageType === BOARD;
    return {
      text: unescapedText('contentTopbar.allPipelinesVerbose'),
      value: ALL_PIPELINES_VALUE,
      disabled,
      tooltip: disabled && /*#__PURE__*/_jsx(FormattedMessage, {
        message: getAllPipelinesTooltipMessage(objectTypeId)
      })
    };
  }, [objectTypeId, pageType]);
  const options = useMemo(() => [allPipelinesOption, ...pipelines.map(pipeline => {
    const canAccessPipeline = getIn(['permission', 'accessLevel'], pipeline) !== HIDDEN;
    return {
      text: pipeline.label,
      value: pipeline.pipelineId,
      disabled: !canAccessPipeline,
      tooltip: !canAccessPipeline && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "filterSidebar.forbiddenPipeline"
      })
    };
  })], [allPipelinesOption, pipelines]);
  const switchPipelines = useSwitchPipelines({
    objectTypeId,
    pageType
  });
  const handleChange = useCallback(event => {
    const value = event.target.value;
    const selectedPipeline = value === ALL_PIPELINES_VALUE ? null : pipelines.find(pipeline => pipeline.pipelineId === value);
    if (selectedPipeline === undefined) {
      throw new Error('Unable to find selected pipeline');
    }
    switchPipelines(selectedPipeline);
  }, [switchPipelines, pipelines]);
  if (hidePipelineSwitcher(objectTypeId) || useVizCoreLib && !segmentData) {
    return null;
  }
  return /*#__PURE__*/_jsx(Select, {
    "data-selenium-test": "pipelineSelector",
    "data-test-id": "pipeline-switcher",
    paddingInlineStart: "200",
    inlineSize: "100%",
    buttonUse: "tertiary-light",
    buttonSize: "small",
    menuWidth: 400,
    onChange: handleChange,
    value: currentPipelineId,
    options: options,
    itemComponent: SelectItemWithTooltip,
    dropdownFooter: /*#__PURE__*/_jsx(Flex, {
      justifyContent: "space-between",
      children: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: getPipelineSettingsHref({
          objectTypeId,
          pipelineId: currentPipelineId
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "indexPage.pipelineSelector.editLink"
        })
      })
    })
  });
};
export default PipelineSwitcher;